import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { setReferenceId } from '../../slices/dashboard/dashboardSlice';
import ConsumerData from '../../components/application/consumer';
import { getApplicationData } from '../../slices/eligibility/eligibilitySlice';
import Loader from '../../components/common/Loader';
// import { tracer } from '../../otel';

function ConsumerId() {
  const [searchParams] = useSearchParams();
  const referenceId = searchParams.get('referenceId');
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false)

  // useEffect(() => {
  //   const span = tracer.startSpan("consumer-landing", {
  //     attributes: {
  //       "custom.reference_id": referenceId, // <- add your custom reference_id here
  //     },
  //   });

  //   return () => {
  //     span.end();
  //   };
  // }, [referenceId]);


  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (referenceId) {
        dispatch(setReferenceId(referenceId));

        setLoader(true);
        try {
          const response = await dispatch(getApplicationData({ reference_id: referenceId }));

          if (response?.payload?.response_code && response?.payload?.response_code !== 'S100') {
            !response?.payload?.error &&
              toast.error(response?.payload?.response_string || 'API request failed');
          }
        } catch (error) {
          toast.error('Failed to fetch application data');
        } finally {
          if (isMounted) setLoader(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [referenceId, dispatch]);

  return (
    <>
      {loader === true ? <Loader /> : <ConsumerData />}
    </>
  );
}

export default ConsumerId;